module.exports = __webpack_public_path__ + "img/logo_DeMeulenbarg-01.f3968236.png";